import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import Select from "react-select";

import {isDesktop} from "utils";
import {getAssignmentsOptions} from "v2/api/Assignees";
import {Assignee} from "v2/api/Records";
import FieldError from "v2/components/FieldError";
import FieldGroup from "v2/components/FieldGroup";
import Loading from "v2/components/Loading";

const AssignmentsSelect = (props) => {
  const {
    data,
    error,
    fieldContainerClassName,
    focus,
    labelClassName,
    onChange,
    routeId,
    selected,
  } = props;

  let content;
  if (!data) {
    content = <Loading inForm />;
  } else if (data.isEmpty()) {
    content = (
      <div className="form-control-static text-warning">
        No gardeners.
      </div>
    );
  } else {
    const options = getAssignmentsOptions(data, routeId);
    content = [
      <Select
        autoBlur
        autofocus={focus && isDesktop()}
        key="select"
        multi
        name="assignments-select"
        onChange={onChange}
        optionRenderer={item => item.htmlLabel}
        options={options}
        placeholder="Search by name or email"
        searchable
        value={selected.toArray()}
        valueRenderer={item => item.htmlLabel} />,
      <span className="help-block erg-no-margin-bottom" key="help">
        <strong>*</strong> Gardener already assigned to a route.
      </span>,
    ];
  }

  return (
    <FieldGroup error={error}>
      <label className={labelClassName}>Gardeners:</label>
      <div className={fieldContainerClassName}>
        {content}
        <FieldError>{error}</FieldError>
      </div>
    </FieldGroup>
  );
};

AssignmentsSelect.propTypes = {
  data: ImmutablePropTypes.listOf(Assignee),
  error: PropTypes.string,
  fieldContainerClassName: PropTypes.string,
  focus: PropTypes.bool,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  routeId: PropTypes.number,
  selected: ImmutablePropTypes.list,
};

export default AssignmentsSelect;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/AssignmentsSelect.js
 **/